<template>
    <div class="form">
        <el-form :model="info" ref="info" label-width="150px" label-position="left" class="demo-info">
            <h3 class="sub-title">基础设置</h3>
            <el-form-item label="活动名称：" prop="name">
                <el-input v-model="info.name" :disabled="true" clearable placeholder="请输入活动名称，不超过20个字"></el-input>
            </el-form-item>
            <el-form-item label="活动时间：" prop="date">
                <el-date-picker
                    v-model="info.date"
                    style="width: 100%"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    :picker-options="expireTimeOption"
                    :disabled="true"
                >
                </el-date-picker>
            </el-form-item>
            <el-form-item label="活动说明：" prop="explain">
                <el-input v-model="info.explain" :disabled="true" type="textarea" :rows="4" clearable placeholder="可对活动的其他信息作说明，如：发货情况等。"></el-input>
            </el-form-item>
            <el-form-item label="活动有效期：" prop="task_time">
                <div>
                    <el-input-number v-model="info.dd" :disabled="true" clearable style="width: 120px" :min="0" :max="30"> </el-input-number> 日
                    <span v-show="info.dd != 30"> <el-input-number v-model="info.hh" :disabled="true" clearable :min="0" :max="23" style="width: 120px; margin-left: 16px"> </el-input-number> 时</span>
                    <span v-show="info.dd != 30"> <el-input-number v-model="info.mm" :disabled="true" clearable :min="0" :max="59" style="width: 120px; margin-left: 16px"> </el-input-number> 分</span>
                </div>
                <p class="tip-text">接龙活动有效期需在15分钟至30天之间 若设置1日，用户开团后，需要在1日内成团，超时则失败</p>
            </el-form-item>
            <el-form-item label="是否限制购买次数：" prop="purchases_type" class="df">
                <el-radio-group v-model="info.purchases_type" :disabled="true">
                    <el-radio label="1">不限制</el-radio>
                    <el-radio label="2">限制每人最多次数</el-radio>
                    <el-input v-model="info.buyLimit" v-show="info.purchases_type == 2" oninput="value=value.replace(/[^\d]/g,'')" style="width: 180px">
                        <template slot="append">次</template></el-input
                    >
                </el-radio-group>
            </el-form-item>
            <el-form-item label="发起接龙返现：" prop="type">
                <el-radio-group v-model="info.type" :disabled="true">
                    <el-radio label="1">返还现金</el-radio>
                </el-radio-group>
                <p class="tip">发起接龙的用户下单后邀请朋友下单，将获得发起人返现奖励</p>
            </el-form-item>
            <el-form-item label="返现设置 ：" class="df">
                <el-input
                    v-model="info.reward_share"
                    :disabled="true"
                    style="width: 180px"
                    oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')"
                >
                    <template slot="append">%</template>
                </el-input>
                <span style="margin: 0 12px">或</span>
                <el-input
                    v-model="info.reward_cash"
                    :disabled="true"
                    style="width: 180px"
                    oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')"
                >
                    <template slot="append">元</template>
                </el-input>
            </el-form-item>
            <el-form-item label="返现条件：">
                <p>自己的接龙成员订单支付完成 7 天内，未申请退款</p>
            </el-form-item>

            <el-form-item label="优惠叠加：" prop="coupon_type">
                <el-radio-group v-model="info.coupon_type" :disabled="true">
                    <el-radio label="1">不叠加其他营销活动或优惠券</el-radio>
                </el-radio-group>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
export default {
    data() {
        return {
            expireTimeOption: {
                disabledDate(date) {
                    //disabledDate 文档上：设置禁用状态，参数为当前日期，要求返回 Boolean
                    return date.getTime() < Date.now() - 24 * 60 * 60 * 1000;
                },
            },
        };
    },
    props: {
        info: {
            type: Object,
            default: () => {
                return {};
            },
        },
    },
};
</script>

<style lang="scss" scoped>
.form {
    padding: 40px 60px;
    width: 80%;
}

::v-deep .el-range-editor.is-disabled input,
::v-deep .el-textarea.is-disabled .el-textarea__inner,
::v-deep .el-input.is-disabled .el-input__inner,
::v-deep .el-radio__input.is-disabled + span.el-radio__label {
    color: #666;
}
.sub-title {
    margin: 60px 0 40px;
    font-size: 18px;
    color: #333;
    margin-right: 10px;
    padding-left: 12px;
    position: relative;
    &:first-child {
        margin-top: 0;
    }
    &::before {
        content: "";
        width: 3px;
        height: 18px;
        background: #2448ff;
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
    }
}
</style>